import { render, staticRenderFns } from "./api.vue?vue&type=template&id=1ed9dbea&scoped=true&"
import script from "./api.vue?vue&type=script&lang=js&"
export * from "./api.vue?vue&type=script&lang=js&"
import style0 from "./api.vue?vue&type=style&index=0&id=1ed9dbea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed9dbea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed9dbea')) {
      api.createRecord('1ed9dbea', component.options)
    } else {
      api.reload('1ed9dbea', component.options)
    }
    module.hot.accept("./api.vue?vue&type=template&id=1ed9dbea&scoped=true&", function () {
      api.rerender('1ed9dbea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/superAdmin/api/api.vue"
export default component.exports